export default function UserMenuOptions(
  userType,
  { sharedBrandSession = false } = {},
) {
  const type = String(userType || "").toLowerCase();
  const changePassword = {
    id: "password",
    buttonName: "Change password",
    buttonAction: "./account/password",
  };

  if (type === "vendoradmin") {
    return [
      {
        id: "register",
        buttonName: "Register account",
        buttonAction: "./register",
      },
      {
        id: 0,
        buttonName: "Add/Edit Materials",
        buttonAction: "./material/add",
      },
      { id: 1, buttonName: "Your Collection", buttonAction: "./collection" },
      { id: 2, buttonName: "Price Update", buttonAction: "./material/price" },
      changePassword,
    ];
  }

  if (type === "vendor") {
    return [
      {
        id: 0,
        buttonName: "Add/Edit Materials",
        buttonAction: "./material/add",
      },
      { id: 1, buttonName: "Your Collection", buttonAction: "./collection" },
      { id: 2, buttonName: "Price Update", buttonAction: "./material/price" },
      changePassword,
    ];
  }

  if (type === "designer") {
    const items = [
      { id: 0, buttonName: "Collection", buttonAction: "./collection" },
      { id: 1, buttonName: "Library", buttonAction: "./library" },
      { id: 2, buttonName: "Contact", buttonAction: "./contact" },
      { id: 3, buttonName: "help", buttonAction: "./help" },
    ];
    if (!sharedBrandSession) {
      items.push(changePassword);
    }
    return items;
  }

  if (type === "guest") {
    return [
      { id: 0, buttonName: "Login", buttonAction: "./" },
      { id: 1, buttonName: "Contact", buttonAction: "./contact" },
      { id: 2, buttonName: "help", buttonAction: "./help" },
    ];
  }
}
